import { Box } from '@material-ui/core';
import { ArticleType, CheckoutSessionStatus, DownPayment } from '@nemuru-eng/js-api-client';

import { AutoCartSummary } from '@/components/modules/_shared/CartSummary/AutoCartSummary';
import { CartSummaryDownPayment } from '@/components/modules/_shared/CartSummary/components/CartSummaryDownPayment';
import { CartSummaryLines } from '@/components/modules/_shared/CartSummary/components/CartSummaryLines';
import { CartSummaryTotals } from '@/components/modules/_shared/CartSummary/components/CartSummaryTotals';
import { CartSummaryData } from '@/components/modules/_shared/CartSummary/types/CartSummaryData';
import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface CartSummaryProps {
  cartSummaryData: CartSummaryData;
  downPayment: DownPayment;
  discount?: number;
  checkoutSessionStatus?: CheckoutSessionStatus | undefined;
  strikethrough?: boolean;
  showAutoTitle?: boolean;
}

export const CartSummary = ({
  cartSummaryData,
  downPayment,
  discount,
  checkoutSessionStatus,
  strikethrough,
  showAutoTitle = true,
}: CartSummaryProps) => {
  const isAuto =
    cartSummaryData.cartSummaryLines.length === 1 &&
    cartSummaryData.cartSummaryLines[0].articleType === ArticleType.AUTOMOBILE;

  if (isAuto) {
    return (
      <AutoCartSummary
        cartSummaryData={cartSummaryData}
        downPayment={downPayment}
        discount={discount}
        checkoutSessionStatus={checkoutSessionStatus}
        strikethrough={strikethrough}
        showTitle={showAutoTitle}
      />
    );
  }

  return (
    <>
      <Font variant="h5" color={strikethrough ? 'error' : 'title'}>
        <Text strong tId={'CART'} />
      </Font>
      <Box pt={1} />
      <CartSummaryLines lines={cartSummaryData.cartSummaryLines} strikethrough={strikethrough} />
      <Box pb={1} />
      <CartSummaryTotals cartSummaryData={cartSummaryData} strikethrough={strikethrough} />
      {downPayment.amount.amount > 0 && (
        <>
          <CustomDivider dashed margin={2} />
          <CartSummaryDownPayment
            cartSummaryData={cartSummaryData}
            downPayment={downPayment}
            discount={discount}
            checkoutSessionStatus={checkoutSessionStatus}
            strikethrough={strikethrough}
          />
        </>
      )}
    </>
  );
};
